import { useState, type FormEvent } from 'react';

interface TrackingSearchProps {
  onSearch: (orderId: string) => void;
  loading: boolean;
  initialValue?: string;
}

const TrackingSearch = ({ onSearch, loading, initialValue = '' }: TrackingSearchProps) => {
  const [value, setValue] = useState(initialValue);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    const trimmed = value.trim().toUpperCase();
    if (trimmed) onSearch(trimmed);
  };

  return (
    <div className="w-full max-w-2xl mx-auto">
      <form onSubmit={handleSubmit} className="relative">
        <div className="flex items-center gap-0 bg-white border border-stone-200 rounded-2xl overflow-hidden focus-within:border-amber-500 transition-colors duration-200">
          <div className="w-12 h-14 flex items-center justify-center text-stone-400 pl-4 flex-shrink-0">
            <i className="ri-search-line text-lg" />
          </div>
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="Introduce tu número de pedido — ej. HLX-2025-042"
            className="flex-1 h-14 px-3 bg-transparent text-sm font-body text-stone-800 placeholder-stone-400 outline-none"
            disabled={loading}
          />
          <button
            type="submit"
            disabled={loading || !value.trim()}
            className="whitespace-nowrap bg-amber-700 hover:bg-amber-800 disabled:bg-stone-300 disabled:cursor-not-allowed text-white text-sm font-medium font-body px-6 h-14 flex items-center gap-2 transition-all duration-200 cursor-pointer"
          >
            {loading ? (
              <i className="ri-loader-4-line animate-spin text-base" />
            ) : (
              <>
                <span>Buscar</span>
                <i className="ri-arrow-right-line text-base" />
              </>
            )}
          </button>
        </div>
      </form>
      <p className="text-center text-xs text-stone-400 font-body mt-3">
        El número de pedido lo encontrarás en el email de confirmación de compra
      </p>
    </div>
  );
};

export default TrackingSearch;
